// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11H9W","col":"styles_col__3HYN7"};